import React from "react";
import { IPanelProps, Panel } from "core/decorators/Panel";
import CartItemsListPanelConfig from "./config/CartItemsListPanelConfig";
import { Intent, MenuItem, Tab, Tabs } from "@blueprintjs/core";
import Label from "core/components/label/Label";
import { BlockVariant, BlockView } from "common/views/block/BlockView.view";
import { BoxView } from "common/views/box/Box.view";
import { ButtonVariant, ButtonView } from "common/views/button/Button.view";
import { CardView } from "common/views/card/Card.view";
import HeadingView from "common/views/heading/Heading.view";
import { FragmentLayout } from "core/components/FragmentLayout";
import Institution from "./entities/Institutions";
import CartCheckoutDetailsForm from "./CartCheckoutDetailsForm";
import { MutationType } from "typegraph";
import * as actionFragments from "./fragments/cartActionFragments";
import * as displayFragments from "./fragments/cartDisplayFragments";
import * as itemContainerFragments from "./fragments/cartItemContainerFragments";
import * as parentContainerFragments from "./fragments/cartParentContainerFragments";
import { FragmentProvider } from "core/components/FragmentProvider";
import ShippableCheckOutDetails from "./ShippableCheckOutDetails";
import { FlexLeft } from "common/fragments/Flex";
import { SeparatorView } from "common/views/separator/Separator.view";
import { TextInputView } from "common/views/textInput/TextInput.view";
import TypographyView from "common/views/typographyView/Typography.view";
import QueryComponent from "core/api/QueryComponent";
import cartCoupon from "./entities/CartCoupon";
import { CartCheckout } from "./entities/CartCheckout";
import styled from "styled-components";
import CartItemDetails from "./utils/CartItemDetails";
import { DropdownSelectView } from "common/views/dropdownSelect/DropdownSelect.view";
import ShippableUserDetails from "./ShippableUserDetails";
import MutationButton from "common/views/button/MutationButton";
import { Product } from "./entities/ProductType";
import { Query } from "core/api/typedQuery";
import "./CartCost.css";
import Loading from "common/fragments/Loading";
import { CheckBoxView } from "common/views/checkbox/Checkbox.view";
import IResolverService from "core/service/resolver/IResolverService";
import ServiceRegistry from "core/util/ServiceRegistry";
import NonIdealState from "common/fragments/NonIdealState";
import DropdownSelect from "common/form/widgets/common/DropdownSelect";
import { ForumToaster } from "panels/forum/forumActions";
interface cartPageState {
    navbarTabID: string;
    applyCoupon: boolean;
    coupon: string;
    subT: number;
    responseMessage: string;
    responseValue: number;
    entryId: any;
    variantId: any;
    quantityInCart: any;
    showCheckOutForm: boolean;
    showShippablePaymentTypeForm: boolean;
    paymentType: string;
    showOrderConfirmation: boolean;
    showOrderReviewScreen: boolean;
    showCartSummaryActions: boolean;
    courseWithPrice: any;
    placeOrderResult: any;
    placeOrderError: any;
    institution: string;
    cartItems: any;
}
const courseFragments = {
    ...displayFragments,
    ...actionFragments,
};

const ItemFragments = FragmentProvider.forFragments(
    "course-item",
    itemContainerFragments
);
const ContainerFragments = FragmentProvider.forFragments(
    "course-container",
    parentContainerFragments
);
interface ICartItemsPanelProps {
    config: any;
    cartItems: any;
}

const ErrorMessage = styled.div`
	color: #f24441;
`;
const SuccessMessage = styled.div`
	color: #07b70b;
`;

const StyledParentDiv = styled.div`
	 {
		display: flex;
	}
`;

const StyledTabDiv = styled.div`
	 {
		flex-grow: 1;
        width: 65%;
	}
`;
const StyledDiv = styled.div`
	 {
		flex-grow: 1;
        width: 35%;
	}
`;

const ProductQuery = Query.queryOne<Product, any>(Product);

let shippableItemInCart = [];

@Panel({
    id: "cartPage-panel",
    configClass: CartItemsListPanelConfig,
    pageParams: true,
})
class CartPagePanel extends React.Component<
    IPanelProps<CartItemsListPanelConfig>,
    cartPageState
> {
    constructor(props) {
        super(props);
        const cartItemDetails = CartItemDetails(props);
        this.state = {
            navbarTabID: "cartItems",
            applyCoupon: false,
            coupon: "",
            subT: cartItemDetails.totalPrice,
            responseMessage: "",
            responseValue: 0,
            entryId: [...cartItemDetails.entryIds],
            variantId: [...cartItemDetails.variantIds],
            quantityInCart: [...props.quantityInCart],
            showCheckOutForm: false,
            showShippablePaymentTypeForm: false,
            paymentType: "",
            showOrderConfirmation: false,
            showOrderReviewScreen: false,
            showCartSummaryActions: true,
            courseWithPrice: [...cartItemDetails.courseWithPrice],
            placeOrderResult: null,
            placeOrderError: null,
            institution: null,
            cartItems: [...cartItemDetails.entryVariantDetails],
        };
        this.handleDetailsContinue = this.handleDetailsContinue.bind(this);
        this.handleShippableDetailsContinue =
            this.handleShippableDetailsContinue.bind(this);
        this.handleCheckoutClick = this.handleCheckoutClick.bind(this);
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        // Check if the props have changed
        if (
            JSON.stringify(nextProps.quantityInCart) !==
            JSON.stringify(prevState.quantityInCart) ||
            JSON.stringify(nextProps.cartItems) !==
            JSON.stringify(prevState.cartItems)
        ) {
            const courseWithPrice = nextProps.cartItems.flatMap(item => {
                const match = nextProps.quantityInCart.find(({ courseId }) => courseId === item.id);
                const courseQuantity = match ? match.courseQuantity : 0;

                return item.variants.map(variant => ({
                    name: item.title,
                    price: courseQuantity * variant.price,
                })).filter(course => course.price > 0); // Exclude items with no price
            });

            const totalPrice = courseWithPrice.reduce((total, course) => total + course.price, 0);

            return {
                quantityInCart: nextProps.quantityInCart,
                subT: totalPrice,
                courseWithPrice: courseWithPrice,

            };
        }
        // Return null if the state does not need to change
        return null;
    }
    handleTabChange = (navbarTabID: any) => {
        if (navbarTabID === "cartItems") {
            this.setState({
                navbarTabID: navbarTabID,
                showCartSummaryActions: true,
            });
        }
        this.setState({ navbarTabID: navbarTabID });
    };

    handleCheckoutClick = () => {
        let discountVal = 0;
        if (this.props.discountResponse) {
            const discountDetails = this.props.discountResponse || null;
            const discount =
                (discountDetails && discountDetails["discount"]) || null;
            const { value } = discount ? discount : { value: 0 };
            discountVal = value;
        }
        this.setState({
            showCartSummaryActions: false,
            showCheckOutForm: this.state.subT - discountVal > 0 ? true : false,
            showOrderReviewScreen:
                this.state.subT - discountVal === 0 ? true : false,
            navbarTabID:
                this.state.subT - discountVal > 0
                    ? "checkoutDetails"
                    : "orderReview",
        });
    };

    handleShippableDetailsContinue = () => {
        this.setState({
            showShippablePaymentTypeForm: true,
            navbarTabID: "paymentType",
        });
    };

    handleDetailsContinue = () => {
        this.setState({
            showOrderReviewScreen: true,
            navbarTabID: "orderReview",
        });
    };

    handlePlaceOrderClick = (result) => {
        this.setState({
            showOrderConfirmation: true,
            navbarTabID: "orderConfirmation",
            placeOrderResult: result,
        });
        if (result && result.data && result.data.successMessage) {
            this.props.actions.resetCart();
        }
    };
    handlePlaceOrderClickError = (err) => {
        this.setState({
            showOrderConfirmation: true,
            navbarTabID: "orderConfirmation",
            placeOrderError: err.graphQLErrors && err.graphQLErrors[0].message,
        });
    }

    maskCreditCardNumber = (cardNumber) => {
        // Convert the card number to a string in case it's a number
        const cardNumberStr = cardNumber.toString();

        // Get the last four digits
        const lastFourDigits = cardNumberStr.slice(-4);

        // Mask the rest of the digits
        const maskedPart = "*".repeat(cardNumberStr.length - 4);

        // Return the masked credit card number
        return maskedPart + lastFourDigits;
    };

    calculateTotal = () => {
        const price = this.props.cartItems.reduce((total, item) => {
            const { courseQuantity: quantity = 0 } = this.props.quantityInCart.find(obj => obj.courseId === item.id) || {};
            const itemPrice = item.variants.reduce((variantTotal, variant) => variantTotal + quantity * variant.price, 0);
            return total + itemPrice;
        }, 0);
        return price;
    };

    handleChange = (name: string, value?: string) => {
        this.setState({ institution: value })
    };

    public render() {
        const {
            navbarTabID,
            subT,
            responseMessage,
            entryId,
            variantId,
            responseValue,
            showCheckOutForm,
            showShippablePaymentTypeForm,
            paymentType,
            showOrderConfirmation,
            showOrderReviewScreen,
            showCartSummaryActions,
            courseWithPrice,
            placeOrderResult,
            placeOrderError,
            institution,
        } = this.state;
        const {
            config,
            cartItems,
            actions,
            quantityInCart,
            cartItemsGroupBuy,
            discountResponse,
            cartUserDetails,
            shippableUserDetails,
        } = this.props;
        let selectedPaymentType = 'CC'
        if (paymentType) {
            selectedPaymentType = paymentType === "Card" ? "CC" : "PO";
        }
        const placeOrderParams = {
            cartItems: this.state.cartItems,
            coupon: this.state.coupon,
            paymentType: selectedPaymentType,
            paymentParams: cartUserDetails
                ? {
                    number: cartUserDetails.cardNumber,
                    cardExpirationMonth: Number(cartUserDetails.expiry_mm),
                    cardExpirationYear: Number(cartUserDetails.expiry_yy),
                    cardId: cartUserDetails.security,
                    cardHolderName: cartUserDetails.name,
                    address1: cartUserDetails.address_one,
                    locality: cartUserDetails.city,
                    region: cartUserDetails.state,
                    postalCode: cartUserDetails.zipCode,
                    country: cartUserDetails.country,
                    amount: subT,
                }
                : null,
            shippingParams: shippableUserDetails
                ? {
                    address1: shippableUserDetails.address_one,
                    locality: shippableUserDetails.city,
                    region: shippableUserDetails.state,
                    postalCode: shippableUserDetails.zipCode,
                    country: shippableUserDetails.country,
                }
                : null,
            groupPurchaseParams: {
                id: institution && institution['id'],
                name: institution && institution['name'],
            }
        };
        let courses = cartItems.length && [...cartItems];
        const discountDetails = discountResponse || null;
        const discount = (discountDetails && discountDetails["discount"]) || null;
        const { value } = discount ? discount : { value: 0 };
        let orderPlacedOrderId = null;
        let placeOrderSuccess = false;
        let placeOrderCCSuccess = false;
        let placeOrderPOSuccess = false;
        let placeOrderInvalidDetails = null;
        if (placeOrderResult && placeOrderResult.entity && placeOrderResult.entity.orderId !== undefined) {
            orderPlacedOrderId = placeOrderResult.entity.orderId;
            placeOrderSuccess = orderPlacedOrderId || orderPlacedOrderId === 0 ? true : false;
            if (orderPlacedOrderId === 0) {
                placeOrderPOSuccess = true;
            } else if (orderPlacedOrderId) {
                placeOrderCCSuccess = true;
            }
            placeOrderInvalidDetails = null;
        }
        if (!placeOrderSuccess && placeOrderError) {
            placeOrderInvalidDetails = placeOrderError;
        }

        return (
            <StyledParentDiv>
                <StyledTabDiv>
                    <Tabs
                        id="CartPageTabs"
                        selectedTabId={navbarTabID}
                        onChange={this.handleTabChange}
                        large
                    >
                        <Tab
                            id="cartItems"
                            title="Cart"
                            disabled={placeOrderSuccess}
                            panel={
                                <StyledDiv>
                                    <React.Fragment>
                                        {cartItems.length ? (
                                            <BoxView viewKey={"cart-items-box"}>
                                                <CheckBoxView
                                                    viewKey={'cart.groupBuy'}
                                                    value={cartItemsGroupBuy}
                                                    onChange={() => actions.setCartItemsGroupBuy(!cartItemsGroupBuy)}
                                                    label={<Label k="cart.items.groupBy" v="Group Buy" />}
                                                />

                                                {cartItemsGroupBuy && (
                                                    <QueryComponent type="many" entity={Institution} args={{}}>
                                                        {({ data, loading }) => {
                                                            if (loading) {
                                                                return null;
                                                            }

                                                            if (!Array.isArray(data) || data.length === 0) {
                                                                return null;
                                                            }
                                                            const institutions = data.map(item => ({ name: item.name, id: item.id }));
                                                            return (
                                                                <React.Fragment>
                                                                    <DropdownSelectView
                                                                        viewKey="institutions"
                                                                        items={institutions}
                                                                        popOverContentStyles={{
                                                                            maxHeight: "200px",
                                                                            overflowY: "scroll"
                                                                        }}
                                                                        itemRenderer={(item: any, { handleSelect }) => {
                                                                            return (
                                                                                <MenuItem
                                                                                    key={item.name}
                                                                                    text={<Label k={item.name} v={item.name} args={{ name: item['name'] }} />}
                                                                                    onClick={handleSelect}
                                                                                />
                                                                            );
                                                                        }}
                                                                        onChange={(item: any) => this.handleChange("institution", item)}
                                                                    >
                                                                        <Label k="Institution" v={institution && institution['name'] || "Select"} args={{ value: institution && institution['name'] }} />
                                                                    </DropdownSelectView>
                                                                </React.Fragment>
                                                            );
                                                        }}
                                                    </QueryComponent>

                                                )}
                                                {courses &&
                                                    courses.map(
                                                        (course, index) => {
                                                            return (
                                                                <ProductQuery params={{ id: course.itemId }} >
                                                                    {
                                                                        ({ data, loading }) => {

                                                                            if (loading) {
                                                                                return <Loading />;
                                                                            }

                                                                            if (!data) {
                                                                                return "Product not found";
                                                                            }

                                                                            if (!shippableItemInCart.length && data.type && data.type.shippable) {
                                                                                shippableItemInCart.push(course.itemId)
                                                                            }

                                                                            return (
                                                                                <CardView
                                                                                    key={index}
                                                                                    viewKey={
                                                                                        "cart-card-view"
                                                                                    }
                                                                                >
                                                                                    <FragmentLayout
                                                                                        fragments={courseFragments}
                                                                                        layout={config.cartItemsLayout}
                                                                                        props={{
                                                                                            course: course,
                                                                                            quantityInCart: quantityInCart,
                                                                                            pageActions: actions,
                                                                                            groupBuy: cartItemsGroupBuy,
                                                                                        }}
                                                                                    />
                                                                                </CardView>
                                                                            )
                                                                        }}
                                                                </ProductQuery>
                                                            );
                                                        }
                                                    )}
                                            </BoxView>
                                        ) : (
                                            <React.Fragment>
                                                    <HeadingView
                                                        viewKey="empty-cart"
                                                        key="empty-cart"
                                                    >
                                                        <Label
                                                            k="empty.cart.message"
                                                            v="No Items Added to Cart"
                                                        />
                                                </HeadingView>
                                            </React.Fragment>
                                        )}
                                    </React.Fragment>
                                </StyledDiv>
                            }
                        />
                        {cartItems.length && showCheckOutForm ? (
                            <Tab
                                id="checkoutDetails"
                                title="Details"
                                // disabled={!showCheckOutForm}
                                disabled={placeOrderSuccess}
                                panel={
                                    <React.Fragment>
                                        {shippableItemInCart.length ? (
                                            <ShippableCheckOutDetails
                                                cartItems={cartItems}
                                                quantityInCart={quantityInCart}
                                                discountResponse={discountResponse}
                                                actions={actions}
                                                saveShippingInfo={actions.saveShippableUserDetails}
                                                shippableUserDetails={shippableUserDetails}
                                                handleContinueClick={this.handleShippableDetailsContinue}
                                            />
                                        ) : (
                                            <CartCheckoutDetailsForm
                                                cartItems={cartItems}
                                                quantityInCart={quantityInCart}
                                                discountResponse={discountResponse}
                                                actions={actions}
                                                cartUserDetails={cartUserDetails}
                                                shippableUserDetails={shippableUserDetails}
                                                handleContinueClick={this.handleDetailsContinue}
                                            />
                                        )}
                                    </React.Fragment>
                                }
                            />
                        ) : null}
                        {cartItems.length && shippableItemInCart.length &&
                            showShippablePaymentTypeForm ? (
                            <Tab
                                id="paymentType"
                                title="Payment"
                                    //disabled={!showShippablePaymentTypeForm}
                                    disabled={placeOrderSuccess}
                                panel={
                                    <React.Fragment>
                                        {showShippablePaymentTypeForm ? (
                                            <React.Fragment>
                                                <TypographyView viewKey="payment.mode.heading">
                                                    <Label
                                                        k={"payment.heading"}
                                                        v={"Payment Mode"}
                                                    />
                                                </TypographyView>
                                                <Label
                                                    k="Select Payment Type"
                                                    v="Select Payment Type"
                                                />
                                                <DropdownSelectView
                                                    viewKey="Payment Type"
                                                    items={["Card", "Check"]}
                                                    popOverContentStyles={{
                                                        maxHeight: "200px",
                                                        overflowY: "scroll",
                                                    }}
                                                    itemRenderer={(
                                                        value: any,
                                                        { handleSelect }
                                                    ) => {
                                                        return (
                                                            <MenuItem
                                                                key={value}
                                                                text={
                                                                    <Label
                                                                        k={value}
                                                                        v={value}
                                                                        args={{ value, }}
                                                                    />
                                                                }
                                                                onClick={handleSelect}
                                                            />
                                                        );
                                                    }}
                                                    onChange={(value: string) => {
                                                        this.setState({ paymentType: value });
                                                    }}
                                                >
                                                    <Label
                                                        k="Payment Type"
                                                        v={paymentType}
                                                        args={{ value: paymentType }}
                                                    />
                                                </DropdownSelectView>
                                            </React.Fragment>
                                        ) : null}

                                        {paymentType &&
                                            paymentType === "Card" ? (
                                            <CartCheckoutDetailsForm
                                                cartItems={cartItems}
                                                quantityInCart={quantityInCart}
                                                    discountResponse={discountResponse}
                                                actions={actions}
                                                    shippableUserDetails={shippableUserDetails}
                                                    cartUserDetails={cartUserDetails}
                                                    handleContinueClick={this.handleDetailsContinue}
                                            />
                                        ) : null}

                                        {paymentType &&
                                            paymentType === "Check" ? (
                                            <React.Fragment>
                                                    <ShippableUserDetails
                                                        userDetails={this.props.shippableUserDetails}
                                                    />
                                                    <MutationButton
                                                        variant={ButtonVariant.PRIMARY}
                                                        viewKey="order.place.complete"
                                                        clazz={CartCheckout}
                                                        params={placeOrderParams}
                                                        clearCacheOnSuccess={true}
                                                        method={MutationType.CREATE}
                                                        // onClick={this.handlePlaceOrderClick}
                                                        onSuccess={(result) => {
                                                            console.log(result);
                                                            this.handlePlaceOrderClick(result);
                                                        }}
                                                        onFailure={(error) => {
                                                            this.handlePlaceOrderClickError(error);
                                                            console.log(error);
                                                        }}
                                                    >
                                                        &nbsp;
                                                        Place Order
                                                    </MutationButton>
                                            </React.Fragment>
                                        ) : null}
                                    </React.Fragment>
                                }
                            />
                        ) : null}
                        {cartItems.length && showOrderReviewScreen ? (
                            <Tab
                                id="orderReview"
                                title="Review"
                                //disabled={!showOrderReviewScreen}
                                disabled={placeOrderSuccess}
                                panel={
                                    <React.Fragment>
                                        <TypographyView viewKey="user.review.heading">
                                            <Label
                                                k={"review.heading"}
                                                v={"Review"}
                                            />
                                        </TypographyView>
                                        <TypographyView viewKey="user.review.message">
                                            <Label
                                                k={"review.message"}
                                                v={`Please confirm your order information.
                                                    Your order will not be submitted until you click 'Place Order'.`}
                                            />
                                        </TypographyView>
                                        {this.calculateTotal() - value > 0 ? (
                                            <BoxView viewKey="entered-details-Preview">
                                                <TypographyView viewKey="userDetails.cardNumber">
                                                    <Label
                                                        k={"number"}
                                                        v={"CardNumber"}
                                                    />
                                                    &nbsp; :&nbsp;
                                                    {this.maskCreditCardNumber(
                                                        cartUserDetails && cartUserDetails.cardNumber
                                                    )}
                                                </TypographyView>
                                                <TypographyView viewKey="user.carExpiry">
                                                    <Label
                                                        k={"expiry"}
                                                        v={"Expiry"}
                                                    />
                                                    &nbsp;:&nbsp;
                                                    {`${cartUserDetails.expiry_mm}/${cartUserDetails.expiry_yy}`}
                                                </TypographyView>
                                                <TypographyView viewKey="user.cardSecurity">
                                                    <Label
                                                        k={"security"}
                                                        v={"Security"}
                                                    />
                                                    &nbsp; :&nbsp;
                                                    {cartUserDetails.security}
                                                </TypographyView>
                                                <TypographyView viewKey="user.billing.information">
                                                    <Label
                                                        k={
                                                            "billing.information"
                                                        }
                                                        v={
                                                            "Billing Information"
                                                        }
                                                    />
                                                </TypographyView>
                                                <TypographyView viewKey="user.Name">
                                                    <Label
                                                        k={"name"}
                                                        v={"Name"}
                                                    />
                                                    &nbsp; : &nbsp;
                                                    {cartUserDetails.name}
                                                </TypographyView>
                                                <TypographyView viewKey="user.AddressState">
                                                    <Label
                                                        k={"state"}
                                                        v={"State"}
                                                    />
                                                    &nbsp;:&nbsp;
                                                    {cartUserDetails.state}
                                                </TypographyView>
                                                <TypographyView viewKey="user.AddressCity">
                                                    <Label
                                                        k={"city"}
                                                        v={"City"}
                                                    />
                                                    &nbsp; : &nbsp;
                                                    {cartUserDetails.city}
                                                </TypographyView>
                                                <TypographyView viewKey="user.Areazipcode">
                                                    <Label
                                                        k={"zipcode"}
                                                        v={"Zipcode"}
                                                    />
                                                    &nbsp; : &nbsp;
                                                    {cartUserDetails.zipCode}
                                                </TypographyView>
                                                <TypographyView viewKey="user.AddressCountry">
                                                    <Label
                                                        k={"country"}
                                                        v={"Country"}
                                                    />
                                                    &nbsp; : &nbsp;
                                                    {cartUserDetails.country}
                                                </TypographyView>
                                                {shippableUserDetails ? (
                                                    <React.Fragment>
                                                        <TypographyView viewKey="user.shipping.information">
                                                            <Label
                                                                k={"shipping.information"}
                                                                v={"Shipping Information"}
                                                            />
                                                        </TypographyView>
                                                        <TypographyView viewKey="user.Name">
                                                            <Label
                                                                k={"name"}
                                                                v={"Name"}
                                                            />
                                                            &nbsp;:&nbsp;
                                                            {
                                                                shippableUserDetails.name
                                                            }
                                                        </TypographyView>
                                                        <TypographyView viewKey="user.AddressState">
                                                            <Label
                                                                k={"state"}
                                                                v={"State"}
                                                            />
                                                            &nbsp; :&nbsp;
                                                            {
                                                                shippableUserDetails.state
                                                            }
                                                        </TypographyView>
                                                        <TypographyView viewKey="user.AddressCity">
                                                            <Label
                                                                k={"city"}
                                                                v={"City"}
                                                            />
                                                            &nbsp; :&nbsp;
                                                            {
                                                                shippableUserDetails.city
                                                            }
                                                        </TypographyView>
                                                        <TypographyView viewKey="user.Areazipcode">
                                                            <Label
                                                                k={"zipcode"}
                                                                v={"Zipcode"}
                                                            />
                                                            &nbsp; :&nbsp;
                                                            {
                                                                shippableUserDetails.zipCode
                                                            }
                                                        </TypographyView>
                                                        <TypographyView viewKey="user.AddressCountry">
                                                            <Label
                                                                k={"country"}
                                                                v={"Country"}
                                                            />
                                                            &nbsp; :&nbsp;
                                                            {
                                                                shippableUserDetails.country
                                                            }
                                                        </TypographyView>
                                                    </React.Fragment>
                                                ) : null}
                                                <MutationButton
                                                    variant={
                                                        ButtonVariant.PRIMARY
                                                    }
                                                    viewKey="order.place.complete"
                                                    clazz={CartCheckout}
                                                    params={{
                                                        ...placeOrderParams,
                                                    }}
                                                    clearCacheOnSuccess={true}
                                                    method={MutationType.UPDATE}
                                                    // onClick={this.handlePlaceOrderClick}
                                                    onSuccess={(result) => {
                                                        console.log(result);
                                                        this.handlePlaceOrderClick(result);
                                                    }}
                                                    onFailure={(error) => {
                                                        console.log(error);
                                                        this.handlePlaceOrderClickError(error);
                                                    }}
                                                >
                                                    Place Order
                                                </MutationButton>
                                            </BoxView>
                                        ) : (
                                                <React.Fragment>
                                                    <MutationButton
                                                        variant={
                                                            ButtonVariant.PRIMARY
                                                        }
                                                        viewKey="order.place.complete"
                                                        clazz={CartCheckout}
                                                        params={placeOrderParams}
                                                        clearCacheOnSuccess={true}
                                                        method={MutationType.UPDATE}
                                                        // onClick={this.handlePlaceOrderClick}
                                                        onSuccess={(result) => {
                                                            console.log(result);
                                                            this.handlePlaceOrderClick(result);
                                                        }}
                                                        onFailure={(error) => {
                                                            console.log(error);
                                                            this.handlePlaceOrderClickError(error);
                                                        }}
                                                    >Place Order
                                                </MutationButton>
                                            </React.Fragment>
                                        )}
                                    </React.Fragment>
                                }
                            />
                        ) : null}
                        {cartItems.length && showOrderConfirmation ? (
                            <Tab
                                id="orderConfirmation"
                                title="Confirm"
                                // disabled={showOrderConfirmation}
                                panel={
                                    <React.Fragment>
                                        {placeOrderCCSuccess ? (
                                            <React.Fragment>
                                                <TypographyView viewKey="order.confirmed.heading">
                                                    <Label
                                                        k={"order.success.text"}
                                                        v={"Congratulations!!!"}
                                                    />
                                                </TypographyView>
                                                <TypographyView viewKey="order.confirmed.message">
                                                    <Label
                                                        k={
                                                            "order.confirmed.message"
                                                        }
                                                        v={`Your order has been confirmed
                                            and we have emailed you a copy. Next step is to  visit the enrolled courses and launch the course.`}
                                                    />
                                                </TypographyView>
                                                <TypographyView viewKey="order.receipt.heading">
                                                    <Label
                                                        k={"receipt.heading"}
                                                        v={"Order Receipt"}
                                                    />
                                                </TypographyView>
                                                <ButtonView
                                                    viewKey={"cart-review"}
                                                    onClick={() =>
                                                        console.log("receipt")
                                                    }
                                                > Print Receipt
                                                </ButtonView>
                                            </React.Fragment>
                                        ) : null}
                                        {placeOrderPOSuccess ? (
                                            <React.Fragment>
                                                <TypographyView viewKey="order.confirmed.heading">
                                                    <Label
                                                        k={"order.success.text"}
                                                        v={"Congratulations!!!"}
                                                    />
                                                </TypographyView>
                                                <TypographyView viewKey="order.confirmed.message">
                                                    <Label
                                                        k={
                                                            "order.confirmed.message"
                                                        }
                                                        v={`We have received the order request. You will be informed once the request is processed by the admin.`}
                                                    />
                                                </TypographyView>
                                            </React.Fragment>
                                        ) : null}
                                        {placeOrderInvalidDetails ? (
                                            <React.Fragment>
                                                <TypographyView viewKey="order.notConfirmed.heading">
                                                    <Label
                                                        k={"order.failure.text"}
                                                        v={"Oops! Your order couldn't be placed. Please try again or reach out to customer support if the issue persists."}
                                                    />
                                                    <ErrorMessage>{placeOrderInvalidDetails}</ErrorMessage>
                                                </TypographyView>
                                                <TypographyView viewKey="order.notConfirmed.message">
                                                    <Label
                                                        k={"order.notConfirmed.message"}
                                                        v={`Order not placed.`}
                                                    />
                                                </TypographyView>
                                            </React.Fragment>
                                        ) : null}
                                    </React.Fragment>
                                }
                            />
                        ) : null}
                    </Tabs>
                </StyledTabDiv>
                <StyledDiv>
                    {cartItems.length ? (
                    <FlexLeft>
                        <BoxView viewKey="cost-summary-box">
                            {!showCartSummaryActions && (
                                !placeOrderSuccess && (
                                    <React.Fragment>
                                        <TypographyView viewKey="summary.checkout.message">
                                            <Label
                                                k={"checkout.message"}
                                                v={`You are ordering ${cartItems.length} item(s).`}
                                            />
                                        </TypographyView>
                                        <SuccessMessage>
                                            &nbsp;
                                            {discountResponse &&
                                                discountResponse["responseValue"] &&
                                                discountResponse["responseMessage"]
                                                ? "Coupon applied"
                                                : ""}
                                        </SuccessMessage>
                                    </React.Fragment>
                                )
                            )}
                            {cartItems.length && !placeOrderSuccess ? (
                                <BlockView
                                    key="secondary"
                                    variant={BlockVariant.CARD_CONTENT}
                                    style={{ flexGrow: 1 }}
                                    viewKey="summary-checkout-box"
                                >
                                    <TypographyView viewKey="cart.item.summary">
                                        <Label
                                            k="cart.items.summary"
                                            v="Cart Summary"
                                        />
                                    </TypographyView>
                                    <BoxView viewKey="CostSummaryBox">
                                        <div style={{ maxWidth: "600px", margin: "0 auto" }}>
                                            <div className="cart">
                                                {courseWithPrice.map((product, index) => (
                                                    <div key={index} className="cart-item">
                                                        <span>{product.name}</span>
                                                        <span className="subtotal">${product.price}</span>
                                                    </div>
                                                ))}
                                                <div className="cart-footer">
                                                    <span>Grand Total</span>
                                                    <span className="total">${responseValue ? (subT - responseValue).toString() : subT.toString()}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </BoxView>
                                    <SeparatorView viewKey="cart-coupon-separator" />
                                    {showCartSummaryActions ? (
                                        <BlockView viewKey="cart.action.buttons">
                                            <TypographyView viewKey="apply.code.coupon.text">
                                                <Label
                                                    k="cart.apply.code.coupon"
                                                    v="Apply Code / Coupon"
                                                />
                                            </TypographyView>
                                            <TextInputView
                                                viewKey="cart.apply.coupon"
                                                placeholder="Coupon"
                                                value={this.state.coupon}
                                                onChange={(value: string) => {
                                                    this.setState({ coupon: value });
                                                    this.setState({ responseMessage: "" });
                                                }}
                                            />
                                            {this.state.applyCoupon && (
                                                <QueryComponent
                                                    entity={cartCoupon}
                                                    type="many"
                                                    args={{
                                                        entryId: entryId,
                                                        variantId: variantId,
                                                        coupon: this.state.coupon,
                                                    }}
                                                >
                                                    {({
                                                        loading, error, data,
                                                    }) => {
                                                        if (loading) {
                                                            return (<p>Please wait...</p>);
                                                        }
                                                        if (error) {
                                                            return (<p>Error:&nbsp;{error}</p>);
                                                        }
                                                        const responseValue =
                                                            data && data["discount"] && data["discount"]["value"];
                                                        if (
                                                            data && data["messageResponse"]
                                                        ) {
                                                            actions.setDiscountResponse(data);
                                                            this.setState({
                                                                applyCoupon: false,
                                                                responseMessage: data && data["messageResponse"],
                                                                responseValue: responseValue,
                                                            });
                                                        }
                                                    }}
                                                </QueryComponent>
                                            )}
                                            {responseValue ? (
                                                <SuccessMessage>
                                                    &nbsp;
                                                    {responseValue && responseMessage ? responseMessage : ""}
                                                </SuccessMessage>
                                            ) : null}
                                            {!responseValue ? (
                                                <ErrorMessage>
                                                    &nbsp;
                                                    {!responseValue && responseMessage ? responseMessage : ""}
                                                </ErrorMessage>) : null}
                                            <div>
                                                <ButtonView
                                                    viewKey="cart.coupon.apply"
                                                    disabled={showCheckOutForm}
                                                    variant={ButtonVariant.PRIMARY}
                                                    onClick={() => this.setState({ applyCoupon: true })}
                                                > Apply
                                                </ButtonView>
                                            </div>
                                        </BlockView>
                                    ) : null}
                                    <SeparatorView viewKey="cart-action-separator" />
                                    {showCartSummaryActions ? (
                                        <BlockView viewKey="cart.action.buttons">
                                            <ButtonView
                                                viewKey="cart.checkout"
                                                variant={ButtonVariant.PRIMARY}
                                                onClick={this.handleCheckoutClick}
                                            > Checkout
                                            </ButtonView>
                                        </BlockView>
                                    ) : null}
                                </BlockView>
                            ) : null}
                        </BoxView>
                    </FlexLeft>
                    ) : null
                    }
                </StyledDiv>
            </StyledParentDiv>
        );
    }
}



// WEBPACK FOOTER //
// ./src/panels/catalog/cart/CartPage.panel.tsx